import React, {useEffect} from "react";
import {useDrag} from 'react-dnd';
import {makeStyles} from "@material-ui/styles";
import {Icon, Paper} from "@material-ui/core";
import {SourceTypes} from "../ToolBarUtils/ItemTypes";
import {getEmptyImage} from "react-dnd-html5-backend";
import Typography from "@material-ui/core/Typography";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
    paper: {
        width: 70,
        height: 70,
        textAlign: 'center',
        paddingTop: '5px',
        margin: '5px',
        border: '1px solid transparent',
        '&:hover': {
            color: theme.palette.primary.main,
            cursor: 'move',
            border: `1px solid ${theme.palette.primary.main}`
        }
    },
    paperDragged: {
        '&:hover': {
            color: theme.palette.primary.light,
            border: `1px solid ${theme.palette.primary.light}`
        }
    },
    label: {
        fontSize: '0.8rem',
        lineHeight: 1,
    },
    labelContainer: {
        height: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    iconContainer: {
        height: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    }
}));

const DragComponent = ({source, icon, label, type}) => {
    const classes = useStyles();
    const [{isDragging}, drag, preview] = useDrag({
        item: {
            ...source,
            type: SourceTypes[type]
        },
        end: (item, monitor) => {
            // const dropResult = monitor.getDropResult();
            // if (item && dropResult) {
            //     alert(`You dropped ${item.type} into ${dropResult.type}!`);
            // }
        },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    });
    useEffect(() => {
        preview(getEmptyImage(), {
            captureDraggingState: true
        })
    }, [preview]);

    return (
        <div ref={drag}>
            <Paper className={clsx(
                {
                    [classes.paperDragged]: isDragging
                },
                classes.paper,
            )}>
                <div className={classes.iconContainer}>
                    <Icon>{icon}</Icon>
                </div>
                <div className={classes.labelContainer}>
                    <Typography className={classes.label}>{label}</Typography>
                </div>

            </Paper>
        </div>
    )
};

export default DragComponent
